/* eslint-disable max-len */
/**
 * Scrolls to the target element only if it's not currently visible in the viewport.
 * If the element is already fully visible, no scrolling occurs.
 *
 * @param {HTMLElement} element - The DOM element to scroll to
 * @param {Object} [options] - Optional scroll behavior configuration
 * @param {ScrollBehavior} [options.behavior='smooth'] - Scroll animation: 'smooth' or 'auto'
 * @param {ScrollLogicalPosition} [options.block='nearest'] - Vertical alignment: 'start', 'center', 'end', or 'nearest'
 * @param {ScrollLogicalPosition} [options.inline='nearest'] - Horizontal alignment: 'start', 'center', 'end', or 'nearest'
 * @returns {void}
 *
 * @example
 * const element = document.getElementById('myElement');
 * scrollToElementIfNeeded(element);
 *
 * @example
 * // With a ref
 * scrollToElementIfNeeded(myRef.current);
 *
 * @example
 * // With custom options
 * scrollToElementIfNeeded(element, { behavior: 'auto', block: 'center' });
 */
export const scrollToElementIfNeeded = (element, options = {}) => {
  if (!element) return;

  const rect = element.getBoundingClientRect();
  const isVisible = (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= window.innerHeight &&
    rect.right <= window.innerWidth
  );

  if (!isVisible) {
    element.scrollIntoView({
      behavior: options.behavior || 'smooth',
      block: options.block || 'nearest',
      inline: options.inline || 'nearest',
    });
  }
};
/* eslint-enable max-len */
